<template>
  <v-skeleton-loader
    :loading="loading"
    transition="scale-transition"
    type="card"
    height="750px"
  >
    <box-apex-chart
      type="bar"
      :icon="icon"
      :title="title"
      :series="this.series"
      :labels="this.labels"
      :color="color"
    >
    </box-apex-chart>
  </v-skeleton-loader>
</template>

<script>
import DashboardService from "@/services/dashboard.service";
import Util from "@/util";
import BoxApexChart from "../chart/BoxApexChart";

export default {
  components: { BoxApexChart },
  props: {
    icon: String,
    title: String,
    subTitle: String,
    color: String,
    dateRange: {
      type: String,
      default: "currentWeek",
    },
  },
  created() {
    this.dateRangeChanged();
  },
  data() {
    return {
      loading: true,
      labels: [],
      series: [],
    };
  },
  watch: {
    // whenever question changes, this function will run
    dateRange: function (newProp, oldProp) {
      this.dateRangeChanged();
    },
  },
  methods: {
    dateRangeChanged() {
      this.loading = true;
      DashboardService.getItemsWatchedByRange(this.dateRange).then((r) => {
        this.series = r.data.series;
        this.labels = r.data.labels;
        this.loading = false;
      });
    },
  },
};
</script>
